import request from '@/utils/request';
import { getCommunityId } from '@/utils/vc.js';

// 获取资产分类统计
export function getHomeAssetCategoryStats() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/home/asset-category-stats',
			method: 'get',
			params: { communityId: getCommunityId() },
		})
			.then(response => {
				const res = response.data;
				if (res.code === 0) {
					resolve(res);
				} else {
					reject(new Error(res.msg || '获取资产分类统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取资产动态
export function getHomeAssetDynamics() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/home/asset-dynamics',
			method: 'get',
			params: { communityId: getCommunityId() },
		})
			.then(response => {
				const res = response.data;
				if (res.code === 0) {
					resolve(res);
				} else {
					reject(new Error(res.msg || '获取资产动态失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//获取资产状态统计
export function getHomeAssetStatusStats() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/home/asset-status-stats',
			method: 'get',
			params: { communityId: getCommunityId() },
		})
			.then(response => {
				const res = response.data;
				if (res.code === 0) {
					resolve(res);
				} else {
					reject(new Error(res.msg || '获取资产状态统计失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//获取首页统计数据
export function getHomeStats() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/home/stats',
			method: 'get',
			params: { communityId: getCommunityId() },
		})
			.then(response => {
				const res = response.data;
				if (res.code === 0) {
					resolve(res);
				} else {
					reject(new Error(res.msg || '获取首页统计数据失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

//获取工作信息
export function getHomeWorkInfo() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/home/work-info',
			method: 'get',
			params: { communityId: getCommunityId() },
		})
			.then(response => {
				const res = response.data;
				if (res.code === 0) {
					resolve(res);
				} else {
					reject(new Error(res.msg || '获取工作信息失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
